import React, { useState, useEffect, useRef } from 'react';
import { FiCopy } from "react-icons/fi";
import axiosInstance from '../helpers/axiosInstance';
import { useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import Swal from 'sweetalert2';

const AddTrip = () => {
  const [startHour, setStartHour] = useState(null);
  const [selectingRow, setSelectingRow] = useState(null);
  const [formData, setFormData] = useState({
    vendor_code: "",
    bayType: "",
    route: "",
    truckLength: ""
  });

  const [rows, setRows] = useState([
    { id: 'row-1', shop_id: '', unloading_location_id: '', bay_id: '', from: null, to: null },
    { id: 'row-2', shop_id: '', unloading_location_id: '', bay_id: '', from: null, to: null },
  ]);

  const [shops, setShops] = useState([]);
  const [unloadingLocations, setUnloadingLocations] = useState([]);
  const [bayTypes, setBayTypes] = useState([]);
  const [bays, setBays] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [searchVendor, setSearchVendor] = useState("");
  const [isVendorDropdownOpen, setIsVendorDropdownOpen] = useState(false);
  const vendorDropdownRef = useRef(null);
  const [rowToRemove, setRowToRemove] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [unloadingLocationsMap, setUnloadingLocationsMap] = useState({});
  const [baysMap, setBaysMap] = useState({});

  const [selectedBayType, setSelectedBayType] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance.get('/api/bay-type')
      .then(response => setBayTypes(response.data.bayTypes))
      .catch(error => console.error("Error fetching bay types:", error));

    axiosInstance.get("/api/vendor/dropdownVendors")
      .then((response) => setVendors(response.data.vendors))
      .catch((err) => console.error(err));
  }, []);



  useEffect(() => {
    if (selectedBayType) {
      axiosInstance.get(`/api/trip/get-shops?bay_type_id=${selectedBayType}`)
        .then(response => setShops(response.data.data))
        .catch(error => console.error("Error fetching shops:", error));
    }
  }, [selectedBayType]);



  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(rows);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setRows(items);
  };



  const handleShopChange = async (index, shopId) => {
    const bayTypeId = selectedBayType;

    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, shop_id: shopId, unloading_location_id: "", bay_id: "" } : row
    );
    setRows(updatedRows);

    if (!bayTypeId) return;

    try {
      const res = await axiosInstance.get('/api/trip/get-unloading', {
        params: { shop_id: shopId, bay_type_id: bayTypeId },
      });
      const locations = res.data.data || [];
      setUnloadingLocationsMap(prev => ({ ...prev, [index]: locations }));
      setBaysMap(prev => ({ ...prev, [index]: [] }));
    } catch (error) {
      console.error("Error fetching unloading locations:", error);
    }
  };



  const handleUnloadingChange = async (index, locationId) => {
    const selectedShopId = rows[index]?.shop_id;

    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, unloading_location_id: locationId, bay_id: "" } : row
    );
    setRows(updatedRows);

    if (!selectedShopId) return;

    try {
      const res = await axiosInstance.get('/api/trip/get-bayNumber', {
        params: { location_id: locationId, shop_id: selectedShopId },
      });
      const bays = res.data.data || [];
      setBaysMap(prev => ({ ...prev, [index]: bays }));
    } catch (error) {
      console.error("Error fetching bays:", error);
    }
  };


  const handleBayChange = (index, bayId) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, bay_id: bayId } : row
    );
    setRows(updatedRows);
  };



  // const handleTimeClick = (row, hour) => {
  //   const newRows = [...rows];
  //   if (startHour === null) {
  //     setStartHour(hour);
  //     setSelectingRow(row);
  //     newRows[row].from = hour;
  //     newRows[row].to = hour;
  //   }
  //   else if (selectingRow === row) {
  //     newRows[row].from = Math.min(startHour, hour);
  //     newRows[row].to = Math.max(startHour, hour);
  //     setStartHour(null);
  //     setSelectingRow(null);
  //   }
  //   else {
  //     newRows[row].from = hour;
  //     newRows[row].to = hour;
  //     setStartHour(null);
  //     setSelectingRow(null);
  //   }

  //   setRows(newRows);
  // };

  const handleCancel = () => {
    setFormData({ vendor_code: "", bayType: "", route: "", truckLength: "" });
    setSearchVendor("");
    setSelectedBayType("");
    setStartHour(null);
    setSelectingRow(null);
    setRows([
      { id: 'row-1', shop_id: '', unloading_location_id: '', bay_id: '', from: null, to: null },
      { id: 'row-2', shop_id: '', unloading_location_id: '', bay_id: '', from: null, to: null },
    ]);
  };

  const filteredVendors = vendors.filter((v) =>
    (v.vendor_code && v.vendor_code.toLowerCase().includes(searchVendor.toLowerCase()))
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (vendorDropdownRef.current && !vendorDropdownRef.current.contains(event.target)) {
        setIsVendorDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getRouteName = (vendor_code, tripNumberStr, routes) => {
    let engine = 'x', kd = 'x', weld = 'x', assembly = 'x', imm = 'x', paint = 'x', others = 'x';

    routes.forEach(r => {
      const name = r.shop_name?.toLowerCase() || "";
      if (name.includes('engine')) engine = 'E';
      if (name.includes('kd')) kd = 'K';
      if (name.includes('weld')) weld = 'W';
      if (name.includes('assembly')) assembly = 'A';
      if (name.includes('imm')) imm = 'I';
      if (name.includes('paint')) paint = 'P';
      if (
        !name.includes('engine') &&
        !name.includes('kd') &&
        !name.includes('weld') &&
        !name.includes('assembly') &&
        !name.includes('imm') &&
        !name.includes('paint')
      ) {
        others = 'O';
      }
    });

    return `${vendor_code}-K-${tripNumberStr}-${engine}${kd}${weld}${assembly}${imm}${paint}${others}`;
  };


  const handleSubmit = async () => {
    console.log(formData)
    console.log(rows)
    if (isSubmitting) return;

    setIsSubmitting(true);

    const filledRoutes = rows.filter(row =>
      row.shop_id && row.unloading_location_id && row.bay_id && row.bay_time_from &&
      row.bay_time_to
    );

    if (!formData.vendor_code || !selectedBayType || !formData.truckLength || filledRoutes.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill all required fields!',
      });
      setIsSubmitting(false);
      return;
    }

    for (let i = 0; i < filledRoutes.length; i++) {
      const { bay_time_from, bay_time_to } = filledRoutes[i];

      // Convert "HH:mm" to minutes since midnight
      const fromMinutes = parseInt(bay_time_from.split(':')[0]) * 60 + parseInt(bay_time_from.split(':')[1]);
      const toMinutes = parseInt(bay_time_to.split(':')[0]) * 60 + parseInt(bay_time_to.split(':')[1]);

      if (toMinutes <= fromMinutes) {
        Swal.fire({
          icon: 'warning',
          title: `'Bay Time To' must be greater than 'Bay Time From'`,
        });
        setIsSubmitting(false);
        return;
      }

      if (i > 0) {
        const prevTo = filledRoutes[i - 1].bay_time_to;
        const prevToMinutes = parseInt(prevTo.split(":")[0]) * 60 + parseInt(prevTo.split(":")[1]);
        if (fromMinutes < prevToMinutes) {
          Swal.fire({
            icon: "warning",
            title: "Next Route Must Start After Previous One",
          });
          setIsSubmitting(false);
          return;
        }
      }
    }

    const routes = filledRoutes.map((row, index) => ({
      shop_id: Number(row.shop_id),
      unloading_location_id: Number(row.unloading_location_id),
      bay_number_id: Number(row.bay_id),
      bay_time_from: row.bay_time_from,
      bay_time_to: row.bay_time_to,
      stop_order: index + 1,
    }));

    const postData = {
      vendor_code: formData.vendor_code,
      bay_type_id: Number(selectedBayType),
      truck_length: formData.truckLength.toLowerCase(),
      routes: routes,
    };

    let tripNumberStr = "01";
    try {
      const res = await axiosInstance.get('/api/trip/latest', {
        params: { vendor_code: formData.vendor_code }
      });
      tripNumberStr = (res.data.lastTripNumber + 1).toString().padStart(2, "0");
    } catch (err) {
      console.error("Failed to fetch latest trip number:", err);
    }

    const tripIdPreview = getRouteName(formData.vendor_code, tripNumberStr, routes);

    Swal.fire({
      title: '<span style="color:#2c3e50;font-weight:bold;">Confirm Trip Submission</span>',
      html: `
    <div style="font-size:16px; color:#333; line-height:1.6; display:grid; grid-template-columns:1fr 1fr; gap:8px 24px; text-align:left;">
  <div><b>Trip ID:</b> ${tripIdPreview}</div>
  <div><b>Vendor Code:</b> ${postData.vendor_code}</div>
  <div><b>Bay Type:</b> ${selectedBayType}</div>
  <div><b>Route:</b> ${routes.length}</div>
  <div><b>Truck Length:</b> ${formData.truckLength}</div>
  <div><b>Time Slots:</b> ${routes.map(r => `${r.bay_time_from}-${r.bay_time_to}`).join(', ')}</div>
</div>

    <hr style="margin:15px 0;">
    <p style="font-size:18px; font-weight:bold; color:#2980b9; text-align:center;">
      Do you want to confirm this Trip with these details?
    </p>
  `,
      showCancelButton: true,
      confirmButtonText: '<span style="font-weight:bold;"> Yes, Confirm</span>',
      cancelButtonText: '<span style="font-weight:bold;"> No, Cancel</span>',
      focusCancel: true,
      width: 600,
      background: '#fdfdfd',
      icon: 'question'
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.post("/api/trip/trips", postData)
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: res.data.message || 'Trip Submitted!',
            });

            // Reset form
            setFormData({ vendor_code: '', truckLength: '', route: '' });
            setSelectedBayType('');
            setSearchVendor('');
            setRows(prevRows =>
              prevRows.map(row => ({
                ...row,
                shop_id: '',
                unloading_location_id: '',
                bay_id: '',
                bay_time_from: '',
                bay_time_to: '',
              }))
            );
            setShops([]);
            setBaysMap({});
            setUnloadingLocationsMap({});
          })
          .catch((err) => {
            Swal.fire({
              icon: 'error',
              title: err.response?.data?.message || 'Failed to submit trip.',
            });
          })
          .finally(() => {
            setIsSubmitting(false);
          });
      } else {
        setIsSubmitting(false); // reset if canceled
      }
    });
  };



  useEffect(() => {
    const generatedRoute = rows.map((row, index) => {
      const shop = shops.find(s => s.id === Number(row.shop_id));
      const unloading = (unloadingLocationsMap[index] || []).find(loc => loc.id === Number(row.unloading_location_id));
      const bay = (baysMap[index] || []).find(b => b.id === Number(row.bay_id));

      const shopChar = row.shop_id && shop?.shop_name ? shop.shop_name[0].toUpperCase() : '';
      const unloadChar = row.unloading_location_id && unloading?.location_name ? unloading.location_name[0].toUpperCase() : '';
      const bayChar = row.bay_id && bay?.number ? bay.number[0].toUpperCase() : '';


      return [shopChar, unloadChar, bayChar].filter(Boolean).join('→');
    })
      .filter(Boolean)
      .join(' -> ');

    setFormData(prev => ({ ...prev, route: generatedRoute }));
  }, [rows, shops, unloadingLocationsMap, baysMap]);


  const addRow = () => {
    setRows((prevRows) => [
      ...prevRows,
      {
        id: `row-${Date.now()}`,
        shop_id: "",
        unloading_location_id: "",
        bay_id: "",
        from: null,
        to: null,
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const i = parseInt(index);
    if (i === 0 || isNaN(i)) return;
    setRows((prevRows) => {
      const updated = [...prevRows];
      updated.splice(i, 1);
      return updated;
    });
    setRowToRemove("");
  };

  const handleBayTimeChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;

    // Only check if it's Bay Time From or Bay Time To
    if (field === "bay_time_from" || field === "bay_time_to") {
      const currentFrom = newRows[index].bay_time_from;
      const currentTo = newRows[index].bay_time_to;

      // Check against previous row
      if (index > 0) {
        const prevTo = newRows[index - 1].bay_time_to;
        if (prevTo && currentFrom && currentFrom < prevTo) {
          Swal.fire({
            icon: "warning",
            title: "Next Route Must Start After Previous One",
          });
          newRows[index][field] = ""; // reset invalid time
        }
      }

      // Check if 'to' is before 'from'
      if (currentFrom && currentTo && currentTo <= currentFrom) {
        Swal.fire({
          icon: "warning",
          title: `'Bay Time To' must be after 'Bay Time From'`,
        });
        newRows[index][field] = ""; // reset invalid time
      }
    }

    setRows(newRows);
  };



  return (
    <div className="container-fluid mt-4">
      <div className="p-4 bg-white mx-md-4 mx-2">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <h5 className="text-dark mb-2 mb-md-0" style={{ fontSize: "27px" }}>ADD TRIP</h5>
          <FiCopy size={24} color="#0A4595" style={{ cursor: "pointer" }} />
        </div>

        <div className="row gx-3 gy-3 mb-3">
          <div className="col-lg-3 col-md-6 position-relative" ref={vendorDropdownRef}>
            <label className="fw-bold mb-2">
              Vendor Code <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={searchVendor}
              onChange={(e) => {
                setSearchVendor(e.target.value);
                setIsVendorDropdownOpen(true);
                setFormData({ ...formData, vendor_code: e.target.value });
              }}
              onClick={() => setIsVendorDropdownOpen(true)}
            />
            {isVendorDropdownOpen && (
              <ul className="dropdown-menu show shadow-sm position-absolute w-100">
                {filteredVendors.length > 0 ? (
                  filteredVendors.map((v) => (
                    <li
                      key={v.id}
                      className="dropdown-item"
                      onClick={() => {
                        setFormData({ ...formData, vendor_code: v.vendor_code });
                        setSearchVendor(v.vendor_code);
                        setIsVendorDropdownOpen(false);
                      }}
                    >
                      {v.vendor_code}
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item text-muted">No vendors found</li>
                )}
              </ul>
            )}
          </div>

          <div className="col-lg-3 col-md-6 position-relative">
            <label className="mb-2 fw-bold">Bay Type <span style={{ color: "red" }}>*</span></label>
            <select
              className="form-select"
              value={selectedBayType}
              onChange={(e) => {
                setSelectedBayType(e.target.value);
                setShops([]);
                setUnloadingLocations([]);
                setBays([]);
              }}
            >
              <option value="" disabled>Select Bay Type</option>
              {bayTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.type_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="mb-2 fw-bold">Route</label>
            <input
              type="text"
              className="form-control"
              value={formData.route}
              readOnly
            />
          </div>

          <div className="col-lg-3 col-md-6 position-relative">
            <label className="mb-2 fw-bold">Truck Length <span style={{ color: "red" }}>*</span></label>
            <select
              className="form-select"
              value={formData.truckLength}
              onChange={(e) => setFormData({ ...formData, truckLength: e.target.value })}
            >
              <option value="">Select</option>
              <option>Small</option>
              <option>Medium</option>
              <option>Large</option>
            </select>
          </div>
        </div>

        <div className="table-responsive">
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="trip-table" direction="vertical">
              {(provided) => (
                <table
                  className="table table-bordered text-center"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{ minWidth: "1000px" }}
                >
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: '#0A4595', color: '#fff' }}>#</th>
                      <th style={{ backgroundColor: '#0A4595', color: '#fff' }}>Shop</th>
                      <th style={{ backgroundColor: '#0A4595', color: '#fff' }}>Unloading Loc</th>
                      <th style={{ backgroundColor: '#0A4595', color: '#fff' }}>Bay</th>
                      {/* {[...Array(24).keys()].map((hour) => (
                        <th key={hour} style={{ backgroundColor: '#0A4595', color: '#fff', whiteSpace: "nowrap" }}>
                          {hour}:00
                        </th>
                      ))} */}
                      <th style={{ backgroundColor: '#0A4595', color: '#fff' }}>Bay Time From</th>
                      <th style={{ backgroundColor: '#0A4595', color: '#fff' }}>Bay Time To</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <Draggable key={row.id} draggableId={row.id} index={index}>
                        {(provided) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <td>{index + 1}</td>
                            <td style={{ minWidth: "120px" }}>
                              <select
                                className="form-select"
                                value={row.shop_id}
                                onChange={(e) => handleShopChange(index, e.target.value)}
                              >
                                <option value="" disabled>Select Shop</option>
                                {shops
                                  .map((shop) => (
                                    <option key={shop.id} value={shop.id}>
                                      {shop.shop_name}
                                    </option>
                                  ))}
                              </select>
                            </td>
                            <td style={{ minWidth: "160px" }}>
                              <select
                                className="form-select"
                                value={row.unloading_location_id || ""}
                                onChange={(e) => handleUnloadingChange(index, e.target.value)}
                              >
                                <option value="" disabled>Select Unloading Location</option>
                                {(unloadingLocationsMap[index] || []).map((loc) => (
                                  <option key={loc.id} value={loc.id}>{loc.location_name}</option>
                                ))}
                              </select>
                            </td>
                            <td style={{ minWidth: "160px" }}>
                              <select
                                className="form-select"
                                value={row.bay_id || ""}
                                onChange={(e) => handleBayChange(index, e.target.value)}
                              >
                                <option value="" disabled>Select Bay Number</option>
                                {(baysMap[index] || [])
                                  // 🔥 Filter out bays already chosen in any other route
                                  .filter(bay => !rows.some((r, i) => i !== index && String(r.bay_id) === String(bay.id)))
                                  .map((bay) => (
                                    <option key={bay.id} value={bay.id}>
                                      {bay.number}
                                    </option>
                                  ))}
                              </select>
                            </td>

                            <td style={{ minWidth: "170px" }}>
                              <input
                                type="time"
                                className="form-control"
                                value={row.bay_time_from || ""}
                                onChange={(e) => handleBayTimeChange(index, "bay_time_from", e.target.value)}
                              />
                            </td>

                            {/* Bay Time To */}
                            <td style={{ minWidth: "170px" }}>
                              <input
                                type="time"
                                className="form-control"
                                value={row.bay_time_to || ""}
                                onChange={(e) => handleBayTimeChange(index, "bay_time_to", e.target.value)}
                              />
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mt-4">
          <button className="btn btn-sm btn-success" onClick={addRow}>Add Row</button>

          <div className="d-flex flex-column flex-md-row align-items-center gap-2">
            <select
              className="form-select form-select-sm"
              style={{ width: '180px' }}
              value={rowToRemove}
              onChange={(e) => setRowToRemove(e.target.value)}
            >
              <option value="">Select Row to Remove</option>
              {rows.map((_, index) => (
                index !== 0 && (
                  <option key={index} value={index}>
                    Row {index + 1}
                  </option>
                )
              ))}
            </select>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => handleRemoveRow(rowToRemove)}
              disabled={rowToRemove === ""}
            >
              Remove Row
            </button>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
          <button className="btn px-4 fw-bold" onClick={() => navigate(-1)} style={{ backgroundColor: "#d2d2d2" }}>
            Back
          </button>

          <div className='d-flex justify-content-center gap-3'>
            <button className="btn px-4" style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }} onClick={handleSubmit}>Add</button>
            <button className="btn btn-secondary px-4" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTrip;
